export const aiCoursesCompare = {
  "comparison": {
    "University of Hull": {
      "basic_info": {
        "university_name": "University of Hull",
        "location": "Hull, United Kingdom",
        "ranking": 701,
        "university_type": "Public"
      },
      "ai_courses": [
        {
          "course_name": "MBA with Artificial Intelligence",
          "course_type": "MBA",
          "duration": "1 year",
          "tuition_fees": "£17,000",
          "ai_focus_areas": [
            "Business Intelligence",
            "Data Analytics"
          ]
        }
      ],
      "specializations": [
        "Business Intelligence",
        "Data Analytics"
      ],
      "career_outcomes": {
        "average_salary": "£42,000",
        "employment_rate": "90%",
        "top_employers": [
          "IBM",
          "Accenture"
        ],
        "job_roles": [
          "Business Analyst",
          "AI Consultant"
        ]
      },
      "student_satisfaction": {
        "overall_score": 78,
        "teaching_quality": 80,
        "course_content": 75,
        "facilities": 72
      },
      "research_strength": {
        "ai_research_ranking": 150,
        "publications_count": 120,
        "research_areas": [
          "Business Intelligence",
          "Data Analytics"
        ]
      }
    },
    "Warwick Business School": {
      "basic_info": {
        "university_name": "Warwick Business School",
        "location": "Coventry, United Kingdom",
        "ranking": 62,
        "university_type": "Public"
      },
      "ai_courses": [
        {
          "course_name": "MBA with Artificial Intelligence",
          "course_type": "MBA",
          "duration": "1 year",
          "tuition_fees": "£34,000",
          "ai_focus_areas": [
            "Machine Learning",
            "Data Science"
          ]
        }
      ],
      "specializations": [
        "Machine Learning",
        "Data Science",
        "Business Strategy"
      ],
      "career_outcomes": {
        "average_salary": "£60,000",
        "employment_rate": "97%",
        "top_employers": [
          "Google",
          "Microsoft"
        ],
        "job_roles": [
          "AI Strategist",
          "Data Scientist"
        ]
      },
      "student_satisfaction": {
        "overall_score": 88,
        "teaching_quality": 90,
        "course_content": 85,
        "facilities": 87
      },
      "research_strength": {
        "ai_research_ranking": 25,
        "publications_count": 350,
        "research_areas": [
          "Machine Learning",
          "Data Science"
        ]
      }
    }
  },
  "comparison_summary": {
    "universities_compared": 2,
    "course_type": "MBA",
    "overall_leader": {
      "university": "Warwick Business School",
      "strength": "Reputation and Career Outcomes",
      "score": 92
    },
    "strength_analysis": {
      "best_teaching": "Warwick Business School",
      "best_research": "Warwick Business School",
      "best_career_outcomes": "Warwick Business School",
      "best_value": "University of Hull"
    },
    "cost_comparison": {
      "lowest_fees": "£17,000",
      "highest_fees": "£34,000",
      "average_fees": "£25,500"
    }
  },
  "recommendations": [
    {
      "category": "course_selection",
      "recommendation": "Choose Warwick Business School for better career outcomes and reputation.",
      "priority": "High",
      "reasoning": "Warwick offers superior teaching quality, research strength, and employment opportunities.",
      "university": "Warwick Business School"
    },
    {
      "category": "value_for_money",
      "recommendation": "Consider University of Hull for more affordable tuition with decent career prospects.",
      "priority": "Medium",
      "reasoning": "While not as highly ranked, University of Hull provides good value for money.",
      "university": "University of Hull"
    }
  ],
  "context": {
    "title": "AI Courses Comparison",
    "summary": "Comparison of MBA programs with AI focus at University of Hull and Warwick Business School.",
    "methodology": "Data gathered from university websites, rankings, and publicly available reports on AI courses.",
    "insights": [
      "Warwick Business School offers superior career outcomes and research opportunities.",
      "University of Hull provides a cost-effective option with good teaching quality.",
      "Both universities offer MBA programs with a strong focus on AI and data analytics."
    ],
    "citations": []
  },
  "tab_name": "ai-courses-compare",
  "evidence_sources": [
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=%22University%20of%20Hull%22%20MBA%20course",
      "title": "Search Results for: \"University of Hull\" MBA course",
      "snippet": "Search results for \"University of Hull\" MBA course from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.8,
      "category": "course_comparison",
      "content_domain": "Course Comparison"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=%22University%20of%20Hull%22%20MBA%20program",
      "title": "Search Results for: \"University of Hull\" MBA program",
      "snippet": "Search results for \"University of Hull\" MBA program from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.8,
      "category": "course_comparison",
      "content_domain": "Course Comparison"
    },
    {
      "source": "Study in UK",
      "url": "https://www.studying-in-uk.org/tuition-fees",
      "title": "UK University Tuition Fees Guide 2025",
      "snippet": "Comprehensive guide to tuition fees at UK universities 2025 including international student costs, financial aid options, and living expenses.",
      "confidence": 0.8,
      "category": "course_comparison",
      "content_domain": "Course Comparison"
    },
    {
      "source": "Masters Portal",
      "url": "https://www.mastersportal.com/articles/2123/mba-tuition-fees-in-the-uk.html",
      "title": "MBA Tuition Fees UK Universities 2025 - Complete Guide",
      "snippet": "Detailed breakdown of MBA tuition fees across UK universities 2025, including international student costs and scholarship opportunities.",
      "confidence": 0.8,
      "category": "course_comparison",
      "content_domain": "Course Comparison"
    },
    {
      "source": "Graduate Outcomes",
      "url": "https://www.graduateoutcomes.ac.uk",
      "title": "MBA Employment Report UK - Graduate Outcomes",
      "snippet": "Employment statistics and career outcomes for MBA graduates from UK universities, including salary data and industry placement.",
      "confidence": 0.8,
      "category": "course_comparison",
      "content_domain": "Course Comparison"
    }
  ],
  "cached": false,
  "timestamp": "2025-08-29T01:24:21.057580",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid",
  "metadata": {
    "analysis_type": "ai_courses_compare",
    "total_universities": 2,
    "course_type": "MBA",
    "response_time": 23.2,
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "ai_courses_compare_v1",
      "web_search_used": true
    }
  }
};
